import apirecebimentoweb from '@/services/api-recebimentoweb';

export default {
  namespaced: true,

  state: {
    list: [],
  },

  getters: {
    list: (state) => state.list,
  },

  // NUNCA ALTERAR state DIRETAMENTE EM ACTIONS
  actions: {
    async find(_, {
      where, ...params
    } = {}) {
      const [{ data }, { data: { count: total } }] = await Promise.all([
        apirecebimentoweb.get('pesagem', { params: { ...where, ...params } }),
        apirecebimentoweb.get('pesagem/count', { params: where }),
      ]);
      return { data, total };
    },

    async findPessoaProdutor(_, {
      where,
    } = {}) {
      const [{ data }] = await Promise.all([
        apirecebimentoweb.get('pesagem/produtor/pessoa', { params: where }),
      ]);
      return data;
    },

    async findMotoristaProdutor(_, {
      where,
    } = {}) {
      const [{ data }] = await Promise.all([
        apirecebimentoweb.get('pesagem/produtor/motorista', { params: where }),
      ]);
      return data;
    },

    async findPesagens(_, {
      tipo, where, ...params
    } = {}) {
      const { data } = await apirecebimentoweb.get('pesagem/produtor/detalhado', { params: { tipo, ...where, ...params } });
      return data;
    },

    async countProdutor(_, { where } = {}) {
      const { data } = await apirecebimentoweb.get('pesagem/produtor/count', { params: where });
      return Number(data.count);
    },

    // CONSULTA SEM CACHE
    async findById(_, { id }) {
      const { data } = await apirecebimentoweb.get(`pesagem/produtor/detalhado/${id}`);
      return data;
    },
  },

  // APENAS O MUTATION FAZ ALTERAÇÕES NO STATE
  mutations: {
    SET_LIST(state, list) {
      state.list = list ?? [];
    },
  },
};
